import script from "./EquipoFrio.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipoFrio.vue?vue&type=script&setup=true&lang=js"

import "./EquipoFrio.vue?vue&type=style&index=0&id=e032c362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e032c362"]])

export default __exports__